/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-23 13:17:28
 * @Explain: 邮件模板
 */
import { IsMultilingualEnum } from '@/pages/mailTemplate/utils/enum/addOrEdit';
import type { HttpResponse } from '../data.d';
import http from '../http';

const MODEL = '/mailTemplate';
const MODEL_NEW = '/mail_template';
const ACCOUNT = '/account';

/** 根据isMuilityLanguage 判断是单语言还是多语言，切换接口及参数 */
const getTempConfig = (data: Record<any, any>, keyArr: any[]) => {
  let url = '';
  let switchReqToUnderline = false;
  if (data.isMuilityLanguage === IsMultilingualEnum.multilingual) {
    url = `${MODEL_NEW}/${keyArr[1]}`;
    switchReqToUnderline = true;
  } else {
    url = `${MODEL}/${keyArr[0]}`;
    switchReqToUnderline = false;
  }
  return {
    url,
    switchReqToUnderline,
  };
};

export default {
  // save_editor_config
  saveEditorConfig(data: Record<any, any>) {
    return http.post(`${ACCOUNT}/save_editor_config`, data);
  },
  // save_editor_config
  getEditorConfig(data: Record<any, any>) {
    return http.post(`${ACCOUNT}/query-account-info`, data);
  },
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 全部列表
  getAllList(data?: Record<any, any>) {
    return http
      .post(`${MODEL}/get-all-templates`, data, {
        params: { switchReqToUnderline: true },
      })
      .then((res) => {
        // TODO: 仅供开发期间使用
        // res?.data?.list?.forEach((item) => {
        //   item.subject = `主题-折扣-{{Contact:Email}}-{{Contact:zero1}}`;
        //   item.previewText = `预览文本-折扣`;
        //   item.subjectAttributesDefaultValue = {
        //     Email: '666@qq.om',
        //     zero1: '',
        //   };
        // });
        return res;
      });
  },
  // 业务偏好
  getPreference() {
    return http.post('/preference/check-exist');
  },
  // 添加
  onAdd(data: Record<any, any>) {
    const { url, switchReqToUnderline } = getTempConfig(data, [
      'add',
      'add_muilty_lang',
    ]);
    return http.post(url, data, {
      params: {
        switchReqToUnderline, // 忽略 attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          // 'isAttributesDefaultValue',
        ]),
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    const { url, switchReqToUnderline } = getTempConfig(data, [
      'update',
      'update_muilty_lang',
    ]);
    return http.post(url, data, {
      params: {
        switchReqToUnderline,
        // 忽略 attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
          // 'isAttributesDefaultValue',
        ]),
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 查询模板是否被锁定 - 单纯查询模板是否被锁定
  getLock(data: Record<any, any>) {
    return http.post(`${MODEL}/lock-info`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 锁定
  onLock(data: Record<any, any>) {
    return http.post(`${MODEL}/lock`, data);
  },
  // 解除锁定
  onUnLock(data: Record<any, any>) {
    return http.post(`${MODEL}/unlock`, data);
  },
  // 校验模板名称是否重复
  checkName(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/check-name`, data);
  },
  // 详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/preview`, data, {
      params: {
        switchReqToUnderline: true,
        ver: 'v2',
        // 忽略 req attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['isAttributesDefaultValue']),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify(['attributes_default_value']),
      },
    });
  },
  // 更新属性
  updateTemplateContactAttributes(data: Record<any, any>) {
    return http.post(`${MODEL_NEW}/update_template_attributes`, data, {
      params: {
        switchReqToUnderline: true,
        ver: 'v2',
        // 忽略 req attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['attributes_default_value']),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify(['attributes_default_value']),
      },
    });
  },
  // 多语言详情
  getBaseTemplate(data: Record<any, any>) {
    return http.post(`${MODEL_NEW}/get_base_template`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 删除
  onDel(data: Record<any, any>) {
    const { url, switchReqToUnderline } = getTempConfig(data, [
      'delete',
      'delete_muilty_lang',
    ]);
    return http.post(url, data, {
      params: { switchReqToUnderline },
    });
  },
  // 发送邮件 - 模板验证
  onSendMail(data: Record<any, any>) {
    return http.post('mail_template/send_test', data, {
      params: {
        switchReqToUnderline: true,
        // 忽略 req variable_pair attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify([
          'variable_pair',
          'variablePair',
          'attributes_default_value',
          'subject_attributes_default_value',
          'subjectAttributesDefaultValue',
          'attributesDefaultValue',
        ]),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'variable_pair',
          'variablePair',
          'subject_attributes_default_value',
          'attributes_default_value',
          'subjectAttributesDefaultValue',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 获取上一次模板发送测试信息
  getLastSendMailData(data: Record<any, any>) {
    return http.post(`${MODEL_NEW}/test_default_value`, data, {
      params: {
        switchReqToUnderline: true,
        // 忽略 req  variablePair 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['variable_pair', 'variablePair']),
        // 忽略 rep variablePair 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'variable_pair',
          'variablePair',
          'subject_attributes_default_value',
          'subjectAttributesDefaultValue',
        ]),
      },
    });
  },
  // 移动文件夹
  onMoveFolders(data: Record<any, any>) {
    return http.post(`${MODEL}/update-template-group`, data);
  },
  // 根据图片url获取base64
  downLoadImg(data: Record<any, any>) {
    return http.post(`${MODEL}/download-img`, data);
  },

  /** transaction */
  // 文件夹列表
  getTransFolderList(data: Record<any, any>) {
    return http.post('transactional_template_group/list', data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 文件夹添加
  onTransFolderAdd(data: Record<any, any>) {
    return http.post('transactional_template_group/add', data);
  },
  // 文件夹编辑
  onTransFolderEdit(data: Record<any, any>) {
    return http.post('transactional_template_group/edit', data);
  },
  // 文件夹删除
  onTransFolderDel(data: Record<any, any>) {
    return http.post('transactional_template_group/delete', data);
  },
  // 移动指定文件夹
  onTransFolderMove(data: Record<any, any>) {
    return http.post('transction_template/move_to_group', data);
  },
  // get_font_family
  getEditorFonts() {
    return http.post(`${MODEL_NEW}/get_font_family`);
  },
  // 列表
  getTransList(data: Record<any, any>) {
    return http.post('transction_template/list', data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 添加
  onTransAdd(data: Record<any, any>) {
    return http.post('transction_template/add', data);
  },
  // 编辑
  onTransEdit(data: Record<any, any>) {
    return http.post('transction_template/update', data);
  },
  // 锁定
  onTransLock(data: Record<any, any>) {
    return http.post('transction_template/lock', data);
  },
  // 解除锁定
  onTransUnLock(data: Record<any, any>) {
    return http.post('transction_template/unlock', data);
  },
  // 校验模板名称是否重复
  checkTransName(data: Record<any, any>): Promise<HttpResponse> {
    return http.post('transction_template/check_name', data);
  },
  // 详情
  getTransDetails(data: Record<any, any>) {
    return http.post('transction_template/preview', data);
  },
  // 域名列表
  getTransDomains() {
    return http.post('transction_template/domain_list');
  },
  // 删除
  onTransDel(data: Record<any, any>) {
    return http.post('transction_template/del', data);
  },
  // 发送邮件 - 模板验证
  onTransSendMail(data: Record<any, any>) {
    return http.post('transction_template/send_email', data);
  },
  // 切换版本
  onTransRollbackVersion(data: Record<any, any>) {
    return http.post('transction_template/rollback', data);
  },
  // 发布版本
  onTransPublishVersion(data: Record<any, any>) {
    return http.post('transction_template/publish', data);
  },
  // 查询事务模板是否被锁定 - 单纯查询模板是否被锁定
  getTransctionLock(data: Record<any, any>) {
    return http.post(`/transction_template/lock_info`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取项目图片列表
  getProjectListImg(data: Record<any, any>) {
    return http.post('cos/list-image', data);
  },
  // 删除项目图片
  onDelProjectImg(data: Record<any, any>) {
    return http.post('cos/delete-image', data);
  },
  // 上传项目图片
  onUploadProjectImg(data: Record<any, any>) {
    return http.post('cos/upload-image', data);
  },
  // 校验图片是否可用
  onVerifyProjectImg(data: Record<any, any>) {
    return http.post('cos/check-valid', data);
  },

  // 校验html
  onPromptHtml(data: Record<any, any>) {
    return http.post(`${MODEL}/prompt`, data);
  },
  // 多语言模板 - 删除
  onDelMuilty(data: Record<any, any>) {
    return http.post(`${MODEL_NEW}/delete_muilty_lang`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
